(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.headerHeight = undefined;
      this.headerResizeObserver = new ResizeObserver(([entry]) => this.setHeaderHeight(entry));
      this.headerResizeObserver.observe(this.header, { box: 'border-box' });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight(entry) {
      const height = Math.round(entry.borderBoxSize[0].blockSize);
      if (height === this.headerHeight) return;
      this.headerHeight = height;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    disconnectedCallback() {
      this.headerResizeObserver.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordsign-collection-product-details"] && !Shopify.designMode) return;
  try {
    
  class ProductDetailBrowser extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-product-card]'));
      this.input = this.querySelector('[data-product-search]');
      this.result = this.querySelector('[data-product-result]');
      this.showAllButton = this.querySelector('[data-product-show-all]');
      this.initialLimit = Number(this.dataset.initialLimit) || 9;
      this.expanded = false;
      this.input?.addEventListener('input', () => this.update());
      this.showAllButton?.addEventListener('click', () => {
        this.expanded = true;
        this.update();
      });
      this.update();
    }

    update() {
      const term = this.input?.value.trim().toLowerCase() || '';
      const matches = this.cards.filter((card) => card.dataset.searchText.includes(term));

      this.cards.forEach((card) => {
        const matchIndex = matches.indexOf(card);
        const shouldLimit = !term && !this.expanded && matchIndex >= this.initialLimit;
        card.hidden = matchIndex === -1 || shouldLimit;
      });

      const visibleCount = this.cards.filter((card) => !card.hidden).length;
      if (this.result) {
        const label = term ? this.dataset.resultsLabel : this.dataset.shownLabel;
        this.result.textContent = label
          .replace('[visible]', visibleCount)
          .replace('[total]', matches.length);
      }

      if (this.showAllButton) {
        this.showAllButton.hidden = Boolean(term) || this.expanded || matches.length <= this.initialLimit;
      }
    }
  }

  if (!customElements.get('product-detail-browser')) {
    customElements.define('product-detail-browser', ProductDetailBrowser);
  }

  } catch(e) { console.error(e); }
})();
})();
